import React from 'react';
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon,
} from '@heroicons/react/24/solid';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 0) return null;

  const goToFirst = () => onPageChange(1);
  const goToLast = () => onPageChange(totalPages);
  const goToPrev = () => onPageChange(Math.max(currentPage - 1, 1));
  const goToNext = () => onPageChange(Math.min(currentPage + 1, totalPages));

  return (
    <div className="flex justify-center items-center py-2 gap-2">
      <button
        onClick={goToFirst}
        disabled={currentPage === 1}
        className="p-2 text-gray-600 hover:text-blue-600 disabled:opacity-40"
        title="First"
      >
        <ChevronDoubleLeftIcon className="h-5 w-5" />
      </button>

      <button
        onClick={goToPrev}
        disabled={currentPage === 1}
        className="p-2 text-gray-600 hover:text-blue-600 disabled:opacity-40"
        title="Previous"
      >
        <ChevronLeftIcon className="h-5 w-5" />
      </button>

      <span className="text-sm font-medium px-2">
        Page {currentPage} of {totalPages}
      </span>

      <button
        onClick={goToNext}
        disabled={currentPage === totalPages}
        className="p-2 text-gray-600 hover:text-blue-600 disabled:opacity-40"
        title="Next"
      >
        <ChevronRightIcon className="h-5 w-5" />
      </button>

      <button
        onClick={goToLast}
        disabled={currentPage === totalPages}
        className="p-2 text-gray-600 hover:text-blue-600 disabled:opacity-40"
        title="Last"
      >
        <ChevronDoubleRightIcon className="h-5 w-5" />
      </button>
    </div>
  );
};

export default Pagination;
